// Приглашение организатора: ?invite=ТОКЕН в ссылке. Храним до входа (регистрация, подтверждение почты),
// после входа кабинет один раз отправляет токен на сервер и показывает результат.

const KEY = 'svod_invite';

const storage = {
    get() {
        try { return window.localStorage.getItem(KEY); } catch { return null; }
    },
    set(value) {
        try { window.localStorage.setItem(KEY, value); } catch { /* приватный режим */ }
    },
    remove() {
        try { window.localStorage.removeItem(KEY); } catch { /* ignore */ }
    },
};

export function captureInvite(location = window.location) {
    const token = (new URLSearchParams(location.search).get('invite') || '').trim();
    if (token) storage.set(token.slice(0, 200));
}

export function getStoredInvite() {
    return storage.get() || '';
}

export function clearStoredInvite() {
    storage.remove();
}

/** Применяет сохранённое приглашение. null — применять нечего или временная ошибка (попробуем позже). */
export async function redeemInviteOnce(api) {
    const token = storage.get();
    if (!token) return null;
    try {
        const res = await api.post('/invites/redeem', { token });
        storage.remove();
        return { ok: true, ...res.data };
    } catch (err) {
        const status = err.response?.status;
        if (status === 400 || status === 404) {
            storage.remove();
            const detail = err.response?.data?.detail;
            return { ok: false, error: typeof detail === 'string' ? detail : 'Приглашение не удалось применить' };
        }
        return null;
    }
}
